import { Card } from 'antd';
import React from 'react';
import WorkOrderTable from '../WorkOrderTable';
import posthog from 'posthog-js';
import { EmptyState } from '../empty_state/EmptyState';
import { ShowAllFooterWorkOrders } from '../WorkOrderTable/TableFooter';
import { WORK_ORDER_STATUSES } from '../../constants/WorkOrderStatuses';
import { WORK_ORDER_DISPLAY_STATUSES } from '../../constants/WorkOrderDisplayStatuses';

const ASSET_ASSOCIATED_INACTIVE_WORK_ORDERS_TARGET_COLLECTION =
	'FETCH_DATA_FROM_SERVER_assetAssociatedInActiveWorkOrders';
export default function AssetWorkOrderHistory({ assetId }) {
	return (
		<Card title="Work History">
			<WorkOrderTable
				CustomHeader={() => <></>}
				preAppliedFilters={{
					assetIds: [assetId],
					displayStatuses: [
						WORK_ORDER_DISPLAY_STATUSES.complete,
						WORK_ORDER_DISPLAY_STATUSES.cancelled,
					],
				}}
				tableStyle={{
					display: 'flex',
					flexDirection: 'column',
					cursor: 'pointer',
					userSelect: 'none',
					padding: '8px 8px',
					marginTop: '-10px',
					marginBottom: '-9px',
				}}
				initialPagination={{ current: 1, pageSize: 3 }}
				targetCollectionName={ASSET_ASSOCIATED_INACTIVE_WORK_ORDERS_TARGET_COLLECTION}
				renderEmptyState={() => (
					<EmptyState
						graphic={
							<img
								alt="There aren't any past work orders for this asset."
								style={{ marginBottom: 8 }}
								src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
							/>
						}
						headline={'No news is good news.'}
						body={
							<div style={{ textAlign: 'center' }}>
								<div style={{ maxWidth: 440, marginBottom: 16 }}>
									There aren't any past work orders for this asset.
								</div>
							</div>
						}
					/>
				)}
				backText="Back to asset"
				openMoreInDefault
				ignoreRefreshCounts
				CustomFooter={ShowAllFooterWorkOrders}
			/>
		</Card>
	);
}
